import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=e267c76c&scoped=true&"
import script from "./PageContent.vue?vue&type=script&lang=js&"
export * from "./PageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e267c76c",
  null
  
)

export default component.exports